import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export default function VideoModal({ isOpen, videoId, onClose, isDarkMode }) {
    useEffect(() => {
        if (isOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = 'unset';
        return () => { document.body.style.overflow = 'unset'; };
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen || !videoId) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4 sm:p-6">
            <div
                className="absolute inset-0 bg-slate-900/70 backdrop-blur-sm animate-in fade-in duration-300"
                onClick={onClose}
            />

            <div className={`relative w-full max-w-3xl rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 slide-in-from-bottom-4 duration-300 ${
                isDarkMode ? 'bg-slate-800' : 'bg-white'
            }`}>
                <button
                    onClick={onClose}
                    className={`absolute top-3 right-3 z-10 p-2 rounded-full transition-colors ${
                        isDarkMode
                            ? 'bg-slate-900/70 hover:bg-slate-900 text-slate-200'
                            : 'bg-white/80 hover:bg-white text-slate-700'
                    }`}
                    aria-label="Close video"
                >
                    <X className="w-5 h-5" />
                </button>

                <div className="aspect-video w-full">
                    <iframe
                        className="w-full h-full"
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                        title="Pono Pilot video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    );
}
